import type { ReactNode } from "react";
import { useReducedMotion } from "motion/react";

import { useWindowScrolled } from "../../hooks/useWindowScrolled";

type FixedTabTopBarProps = {
  children: ReactNode;
};

export function FixedTabTopBar({ children }: FixedTabTopBarProps) {
  const scrolled = useWindowScrolled();
  const prefersReducedMotion = useReducedMotion();

  return (
    <header
      className="screen0-fixed-top-bar"
      data-scrolled={scrolled ? "true" : "false"}
      style={
        prefersReducedMotion
          ? undefined
          : { transition: "box-shadow 220ms ease, background-color 220ms ease" }
      }
    >
      <div className="screen0-fixed-top-bar-inner">{children}</div>
    </header>
  );
}
